// sitemap 国际化处理
// https://developers.google.com/search/docs/advanced/crawling/localized-versions?visit_id=637865516473006607-3163220162&rd=1
// sitemap-i18n
// https://sitemap.nuxtjs.org/usage/sitemap-options/#i18n-optional---string--object
import { countrysList, getDefaultLang, countryOfLang } from './country'
// 语言对照
export const LanguageIsoMap = countryOfLang()

function getIsoLocales(locales = []) {
  return locales.map((locale) => {
    return {
      code: locale,
      iso: LanguageIsoMap[locale] || getDefaultLang(),
    }
  })
}

// 上线的国家
const locales = countrysList()
// 上线的游戏
const pages = [
  '/',
  '/lordsmobile',
  '/pubgm',
  '/mobile-legends',
  '/genshin',
  '/genshin-en',
  '/infinity-kingdom',
  '/state-of-survival',
  '/infinity-war',
  '/puzzles-survival',
  '/soul-land3d',
  '/guardians-of-cloudia',
  '/call-me-emperor',
  '/shining-nikki',
  '/game-of-sultans',
  '/turbo-vpn',
  '/vpn-proxy-master',
  '/free-fire',
]

const sitemapConfigs = {
  path: '/sitemap.xml',
  hostname: 'https://www.toplupe.com',
  cacheTime: 1000 * 60 * 60 * 24,
  gzip: true,
  generate: false,
  // exclude: [],
  defaults: {
    changefreq: 'always',
    priority: 1,
    lastmod: new Date(),
  },
  i18n: {
    defaultLocale: 'en',
    locales: getIsoLocales(locales),
    routesNameSeparator: '___',
  },
  routes: () => {
    const result = []
    locales.forEach((locale) => {
      result.push(
        ...pages.map((page) => {
          return {
            name: `${page.replace('/', '') || 'index'}___${locale}`,
            url: `/${locale}${page}`,
            changefreq: 'always',
            lastmod: new Date(),
          }
        })
      )
    })
    return result
  },
}

export default sitemapConfigs
